module.exports = __webpack_public_path__ + "img/icone_camera_inverse.97398e63.svg";